import { initSubRoutes } from '../../../../utils/router';

const RouteQuestionsLoginOublie = initSubRoutes({
    route: '/questions/:token',
    subroutes: {},
    nom: 'Questions pour récupération de login oublié',
});

export default RouteQuestionsLoginOublie;
